import React, { useState } from "react";
import {
  NavLink,
  useLocation,
  useNavigate,
} from "react-router-dom";
import {
  FiArrowLeft,
  FiCalendar,
  FiCheck,
  FiChevronRight,
  FiCopy,
  FiGift,
  FiHome,
  FiMail,
  FiShield,
  FiUser,
} from "react-icons/fi";
import { MdOutlineAdminPanelSettings, MdPersonSearch } from "react-icons/md";

import { RoutesPaths } from "../Router/constant";

const getInitials = (name = "") =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join("") || "?";

export default function AdminDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);

  // Admin object passed from the Admin management list
  const admin = location.state?.admin;

  const adminName =
    admin?.fullName ||
    admin?.name ||
    admin?.username ||
    "N/A";

  const formattedDate = admin?.createdAt
    ? new Date(admin.createdAt).toLocaleDateString("en-GB")
    : "N/A";

  const dobValue =
    admin?.dob ||
    admin?.dateOfBirth ||
    admin?.birthDate;

  const formattedDob = dobValue
    ? new Date(dobValue).toLocaleDateString("en-GB")
    : "N/A";

  const role = admin?.role || admin?.userRole || "admin";

  const copyAdminId = async () => {
    try {
      await navigator.clipboard.writeText(admin?._id || "");
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (error) {
      console.error("Copy failed:", error);
    }
  };

  const goBack = () => navigate(RoutesPaths.ADMINMANAGEMENT);

  const infoItems = [
    { label: "Full name", value: adminName, Icon: FiUser },
    { label: "Email", value: admin?.email || "N/A", Icon: FiMail },
    { label: "Date of birth", value: formattedDob, Icon: FiGift },
    { label: "Created date", value: formattedDate, Icon: FiCalendar },
  ];

  return (
    <div className="container-fluid qd-page">
      {/* Breadcrumb */}
      <nav className="qd-breadcrumb">
        <NavLink to={RoutesPaths.DASHBOARD} aria-label="Dashboard">
          <FiHome />
        </NavLink>
        <FiChevronRight />
        <NavLink to={RoutesPaths.ADMINMANAGEMENT}>Admin management</NavLink>
        <FiChevronRight />
        <span className="qd-breadcrumb-current">Admin details</span>
      </nav>

      {admin ? (
        <>
          {/* Profile card */}
          <div className="qd-card qu-profile">
            <div className="qu-identity">
              <div className="qu-avatar">{adminName !== "N/A" ? getInitials(adminName) : "?"}</div>
              <div className="qu-identity-text">
                <h2 className="qu-name">{adminName}</h2>
                <div className="qu-pills">
                  <span className="qu-pill qu-pill-active">
                    <FiShield />
                    <span className="text-capitalize">{role}</span>
                  </span>
                </div>
                {admin?._id && (
                  <div className="qu-userid">
                    <span>Admin ID: {admin._id}</span>
                    <button
                      type="button"
                      className="qu-copy"
                      onClick={copyAdminId}
                      title={copied ? "Copied" : "Copy admin ID"}
                      aria-label="Copy admin ID"
                    >
                      {copied ? <FiCheck /> : <FiCopy />}
                    </button>
                  </div>
                )}
              </div>
            </div>

            <div className="qu-info-grid qad-info-grid">
              {infoItems.map(({ label, value, Icon }) => (
                <div className="qu-info" key={label}>
                  <span className="qu-info-icon">
                    <Icon />
                  </span>
                  <div className="qu-info-text">
                    <span>{label}</span>
                    <strong>{value}</strong>
                  </div>
                </div>
              ))}
            </div>

            <div className="qu-art" aria-hidden="true">
              <span className="qu-art-circle" />
              <MdOutlineAdminPanelSettings className="qu-art-person" />
            </div>
          </div>

          <div className="qad-actions">
            <button type="button" className="qd-btn qv-cancel-btn" onClick={goBack}>
              <FiArrowLeft /> Back
            </button>
          </div>
        </>
      ) : (
        <div className="qd-card qd-panel">
          <div className="qu-empty">
            <span className="qu-empty-art">
              <MdPersonSearch />
            </span>
            <h6>Admin details not available</h6>
            <p>Open an admin from the Admin management list to see their details.</p>
            <button type="button" className="qd-btn qd-btn-primary" onClick={goBack}>
              <FiArrowLeft /> Back to admin management
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
